export default __webpack_public_path__ + "static/media/doge.11657b09.png";